export const getMyLeaveDetailsQuery = `
query leavedetailbyme($id:String!){
    leaveDetailsByMe(id: $id){
      user{
        email
      }
      status
      takedLeave
      leaveType {
        id
        name
      }
      leaveCount
      workFromHome
    }
      }`;

export const submitMutationWFh = `
  mutation requestforWFH($input: WfhInput!){  

requestForWfh(input: $input) {  

              wfhrequest {  

                requestedDate  

                startDate  

                endDate  

                reason  

                totalDays  

                task  

                teamApproval  

                hrApproval  

                lastUpdate  

                user {  

                  id  

                  firstName  

                }  
                approvalStatus{
                  id
                  approver{
                    id
                    firstName
                    lastName
                  }
                  status
                }

              }  

    message

    success

    error

            }

          }`;

